var modNavigationLinks = function(){
    var scope = ".js-mod-navigation-links";
    ui.ready(
        scope,
        function($mod){
            this.header = document.getElementById('myHeader');
            this.navigationLink = document.getElementById('navigationLink');
            function calcHeight(){
                let header = document.getElementById('myHeader');
                let navigationLink = document.getElementById('navigationLink');
                var offsetHeight = header.offsetHeight;
                navigationLink.style.top = offsetHeight+"px";
            }
            calcHeight();
            new ResizeObserver(calcHeight).observe(this.header);

        }
    );
}();
